
$("document").ready(function () {
    $(".tab-slider--body").first().show();
});

$(".tab-slider--nav li").click(function () {
    $(".tab-slider--body").hide();
    const tabLabel = $(this).attr('data-tab-label');
    const innerText = $(this).text();

    toggleSlide(tabLabel);
    setActiveTab(tabLabel);
    setBannerClass(tabLabel);
    updateBannerText(innerText);
});

function setBannerClass(tabLabel) {
    const $dashboardBanner = $('.dashboard-banner');

    if (tabLabel === "tab2") {
        $dashboardBanner.addClass('dashboard-banner--junior');
    } else {
        $dashboardBanner.removeClass('dashboard-banner--junior');
    }
}

function setActiveTab(tabLabel) {
    $(".tab-slider--nav li").removeClass("active");
    $('.tab-slider--nav').find(`[data-tab-label='${tabLabel}']`).addClass("active");

    $("#" + tabLabel).fadeIn();
    initiateTimelineSlider(tabLabel)
}

function toggleSlide(tabLabel) {
    switch (tabLabel) {
        case 'tab2':
            $('.tab-slider--tabs').addClass('slide');
            break;
        default:
            $('.tab-slider--tabs').removeClass('slide');
    }
}

function updateBannerText(newValue) {
    $('.dashboard-banner__label').text(newValue);
}


//iPad scaling bug
if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
    var viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
        viewport.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0';
        document.body.addEventListener('gesturestart', function () {
            viewport.content = 'width=device-width, minimum-scale=1.0, maximum-scale=2.0';
        }, false);
    }
}

/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
// (function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);

(function ($, sr) {

    // debouncing function from John Hann
    // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    var debounce  = function (func, threshold, execAsap) {
        var timeout;

        return function debounced() {
            var obj = this, args = arguments;

            function delayed() {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            };

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100);
        };
    }
    // smartresize
    jQuery.fn[sr] = function (fn) {
        return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
    };

})(jQuery, 'smartresize');
/*!
* jquery.counterup.js 1.0
*
* Copyright 2013, Benjamin Intal http://gambit.ph @bfintal
* Released under the GPL v2 License
*
* Date: Nov 26, 2013
*/
(function (e) {
    "use strict";
    e.fn.counterUp = function (t) {
        var n = e.extend({ time: 400, delay: 10 }, t);
        return this.each(function () {
            var t = e(this), r = n, i = function () {
                var e = [], n = r.time / r.delay, i = t.text(), s = /[0-9]+,[0-9]+/.test(i);
                i     = i.replace(/,/g, "");
                var o = /^[0-9]+$/.test(i), u = /^[0-9]+\.[0-9]+$/.test(i), a = u ? (i.split(".")[1] || []).length : 0;
                for (var f = n; f >= 1; f--) {
                    var l = parseInt(i / n * f);
                    u && (l = parseFloat(i / n * f).toFixed(a));
                    if (s) while (/(\d+)(\d{3})/.test(l.toString())) l = l.toString().replace(/(\d+)(\d{3})/, "$1,$2");
                    e.unshift(l)
                }
                t.data("counterup-nums", e);
                t.text("0");
                var c = function () {
                    t.text(t.data("counterup-nums").shift());
                    if (t.data("counterup-nums").length) setTimeout(t.data("counterup-func"), r.delay); else {
                        delete t.data("counterup-nums");
                        t.data("counterup-nums", null);
                        t.data("counterup-func", null)
                    }
                };
                t.data("counterup-func", c);
                setTimeout(t.data("counterup-func"), r.delay)
            };
            t.waypoint(i, { offset: "100%", triggerOnce: !0 })
        })
    }
})(jQuery);
/**
 * jquery.matchHeight-min.js v0.5.2
 * http://brm.io/jquery-match-height/
 * License: MIT
 */
(function (c) {
    var f             = -1, g = -1, q = function (a) {
        var b = null, d = [];
        c(a).each(function () {
            var a = c(this), l = a.offset().top - k(a.css("margin-top")), m = 0 < d.length ? d[d.length - 1] : null;
            null === m ? d.push(a) : 1 >= Math.floor(Math.abs(b - l)) ? d[d.length - 1] = m.add(a) : d.push(a);
            b = l
        });
        return d
    }, k              = function (a) {
        return parseFloat(a) || 0
    }, n              = function (a) {
        var b = { byRow: !0, remove: !1, property: "height" };
        "object" === typeof a && (b = c.extend(b, a));
        "boolean" === typeof a && (b.byRow = a);
        "remove" === a && (b.remove = !0);
        return b
    }, b              = c.fn.matchHeight = function (a) {
        a =
            n(a);
        if (a.remove) {
            var e = this;
            this.css(a.property, "");
            c.each(b._groups, function (a, b) {
                b.elements = b.elements.not(e)
            });
            return this
        }
        if (1 >= this.length) return this;
        b._groups.push({ elements: this, options: a });
        b._apply(this, a);
        return this
    };
    b._groups         = [];
    b._throttle       = 80;
    b._maintainScroll = !1;
    b._beforeUpdate   = null;
    b._afterUpdate    = null;
    b._apply          = function (a, e) {
        var d = n(e), h = c(a), l = [h], m = c(window).scrollTop(), g = c("html").outerHeight(!0),
            f                                                         = h.parents().filter(":hidden");
        f.css("display", "block");
        d.byRow && (h.each(function () {
            var a              =
                    c(this), b = "inline-block" === a.css("display") ? "inline-block" : "block";
            a.data("style-cache", a.attr("style"));
            a.css({
                display: b,
                "padding-top": "0",
                "padding-bottom": "0",
                "margin-top": "0",
                "margin-bottom": "0",
                "border-top-width": "0",
                "border-bottom-width": "0",
                height: "100px"
            })
        }), l = q(h), h.each(function () {
            var a = c(this);
            a.attr("style", a.data("style-cache") || "").css("height", "")
        }));
        c.each(l, function (a, b) {
            var e = c(b), f = 0;
            d.byRow && 1 >= e.length || (e.each(function () {
                var a         = c(this), b = {
                    display: "inline-block" === a.css("display") ?
                        "inline-block" : "block"
                };
                b[d.property] = "";
                a.css(b);
                a.outerHeight(!1) > f && (f = a.outerHeight(!1));
                a.css("display", "")
            }), e.each(function () {
                var a = c(this), b = 0;
                "border-box" !== a.css("box-sizing") && (b += k(a.css("border-top-width")) + k(a.css("border-bottom-width")), b += k(a.css("padding-top")) + k(a.css("padding-bottom")));
                a.css(d.property, f - b)
            }))
        });
        f.css("display", "");
        b._maintainScroll && c(window).scrollTop(m / g * c("html").outerHeight(!0));
        return this
    };
    b._applyDataApi   = function () {
        var a = {};
        c("[data-match-height], [data-mh]").each(function () {
            var b              =
                    c(this), d = b.attr("data-match-height") || b.attr("data-mh");
            a[d]               = d in a ? a[d].add(b) : b
        });
        c.each(a, function () {
            this.matchHeight(!0)
        })
    };
    var p             = function (a) {
        b._beforeUpdate && b._beforeUpdate(a, b._groups);
        c.each(b._groups, function () {
            b._apply(this.elements, this.options)
        });
        b._afterUpdate && b._afterUpdate(a, b._groups)
    };
    b._update         = function (a, e) {
        if (e && "resize" === e.type) {
            var d = c(window).width();
            if (d === f) return;
            f = d
        }
        a ? -1 === g && (g = setTimeout(function () {
            p(e);
            g = -1
        }, b._throttle)) : p(e)
    };
    c(b._applyDataApi);
    c(window).bind("load",
        function (a) {
            b._update(!1, a)
        });
    c(window).bind("resize orientationchange", function (a) {
        b._update(!0, a)
    })
})(jQuery);
$.fn.matchHeight._maintainScroll = true;
$('.match-height').matchHeight();
$('.eq-height').matchHeight();
$('.same-height').matchHeight();

/* Placeholders.js v4.0.1 */
/*!
 * The MIT License
 *
 * Copyright (c) 2012 James Allardice
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */
// !function(a){"use strict";function b(){}function c(){try{return document.activeElement}catch(a){}}function d(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return!0;return!1}function e(a,b,c){return a.addEventListener?a.addEventListener(b,c,!1):a.attachEvent?a.attachEvent("on"+b,c):void 0}function f(a,b){var c;a.createTextRange?(c=a.createTextRange(),c.move("character",b),c.select()):a.selectionStart&&(a.focus(),a.setSelectionRange(b,b))}function g(a,b){try{return a.type=b,!0}catch(c){return!1}}function h(a,b){if(a&&a.getAttribute(B))b(a);else for(var c,d=a?a.getElementsByTagName("input"):N,e=a?a.getElementsByTagName("textarea"):O,f=d?d.length:0,g=e?e.length:0,h=f+g,i=0;h>i;i++)c=f>i?d[i]:e[i-f],b(c)}function i(a){h(a,k)}function j(a){h(a,l)}function k(a,b){var c=!!b&&a.value!==b,d=a.value===a.getAttribute(B);if((c||d)&&"true"===a.getAttribute(C)){a.removeAttribute(C),a.value=a.value.replace(a.getAttribute(B),""),a.className=a.className.replace(A,"");var e=a.getAttribute(I);parseInt(e,10)>=0&&(a.setAttribute("maxLength",e),a.removeAttribute(I));var f=a.getAttribute(D);return f&&(a.type=f),!0}return!1}function l(a){var b=a.getAttribute(B);if(""===a.value&&b){a.setAttribute(C,"true"),a.value=b,a.className+=" "+z;var c=a.getAttribute(I);c||(a.setAttribute(I,a.maxLength),a.removeAttribute("maxLength"));var d=a.getAttribute(D);return d?a.type="text":"password"===a.type&&g(a,"text")&&a.setAttribute(D,"password"),!0}return!1}function m(a){return function(){P&&a.value===a.getAttribute(B)&&"true"===a.getAttribute(C)?f(a,0):k(a)}}function n(a){return function(){l(a)}}function o(a){return function(){i(a)}}function p(a){return function(b){return v=a.value,"true"===a.getAttribute(C)&&v===a.getAttribute(B)&&d(x,b.keyCode)?(b.preventDefault&&b.preventDefault(),!1):void 0}}function q(a){return function(){k(a,v),""===a.value&&(a.blur(),f(a,0))}}function r(a){return function(){a===c()&&a.value===a.getAttribute(B)&&"true"===a.getAttribute(C)&&f(a,0)}}function s(a){var b=a.form;b&&"string"==typeof b&&(b=document.getElementById(b),b.getAttribute(E)||(e(b,"submit",o(b)),b.setAttribute(E,"true"))),e(a,"focus",m(a)),e(a,"blur",n(a)),P&&(e(a,"keydown",p(a)),e(a,"keyup",q(a)),e(a,"click",r(a))),a.setAttribute(F,"true"),a.setAttribute(B,T),(P||a!==c())&&l(a)}var t=document.createElement("input"),u=void 0!==t.placeholder;if(a.Placeholders={nativeSupport:u,disable:u?b:i,enable:u?b:j},!u){var v,w=["text","search","url","tel","email","password","number","textarea"],x=[27,33,34,35,36,37,38,39,40,8,46],y="#ccc",z="placeholdersjs",A=new RegExp("(?:^|\\s)"+z+"(?!\\S)"),B="data-placeholder-value",C="data-placeholder-active",D="data-placeholder-type",E="data-placeholder-submit",F="data-placeholder-bound",G="data-placeholder-focus",H="data-placeholder-live",I="data-placeholder-maxlength",J=100,K=document.getElementsByTagName("head")[0],L=document.documentElement,M=a.Placeholders,N=document.getElementsByTagName("input"),O=document.getElementsByTagName("textarea"),P="false"===L.getAttribute(G),Q="false"!==L.getAttribute(H),R=document.createElement("style");R.type="text/css";var S=document.createTextNode("."+z+" {color:"+y+";}");R.styleSheet?R.styleSheet.cssText=S.nodeValue:R.appendChild(S),K.insertBefore(R,K.firstChild);for(var T,U,V=0,W=N.length+O.length;W>V;V++)U=V<N.length?N[V]:O[V-N.length],T=U.attributes.placeholder,T&&(T=T.nodeValue,T&&d(w,U.type)&&s(U));var X=setInterval(function(){for(var a=0,b=N.length+O.length;b>a;a++)U=a<N.length?N[a]:O[a-N.length],T=U.attributes.placeholder,T?(T=T.nodeValue,T&&d(w,U.type)&&(U.getAttribute(F)||s(U),(T!==U.getAttribute(B)||"password"===U.type&&!U.getAttribute(D))&&("password"===U.type&&!U.getAttribute(D)&&g(U,"text")&&U.setAttribute(D,"password"),U.value===U.getAttribute(B)&&(U.value=T),U.setAttribute(B,T)))):U.getAttribute(C)&&(k(U),U.removeAttribute(B));Q||clearInterval(X)},J);e(a,"beforeunload",function(){M.disable()})}}(this);

// Progress Bar Meter
function meterReset() {

    var windowWidth = $(window).width();
    var meterValue  = $('.bar .meter').attr('data-complete');
    var progressBar = $('.bar .meter');

    if (meterValue < 60) {
        $('.bar, .bar .meter').css('color', '#164373');
    }

    $('.progress .bar').attr('data-value', meterValue);
    $('.progress .completed').html(meterValue);

    if (windowWidth <= 1000) {
        $(progressBar).css('width', meterValue + '%');
    } else {
        $(progressBar).css('height', meterValue + '%');
    }
}

$(window).resize(function () {

    $('.dashboard-nav ul').removeAttr('style');

    // On window resize reset meter
    if ($('.progress').length > 0) {

        $('.bar .meter').removeAttr('style');
        meterReset();
    }
});


$("a.nav-toggle").click(function () {
    $('body').toggleClass('move-share');
    $('header').toggleClass('nav-active');
});

// Search Show / Hide
$('.search-btn').click(function (e) {
    e.preventDefault();
    $('#search-bar').slideToggle(200);
    $('body,html').animate({
            scrollTop: 0
        }, 300
    );
});

// Pop up trigger
$('.login-trigger').click(function () {

    $('.login-popup').toggleClass('active');
    $('.login-popup .wrapper').toggleClass('open');
});

// Dashboard Menu SlideToggle
$('.dashboard-trigger').click(function (e) {
    e.preventDefault();
    var widthWindow = $(window).width();

    if (widthWindow <= 1020) {
        $(this).siblings('ul').slideToggle(200);
    }
});

// Hide/ Open Custom Dropdown UL
$('.dropdown-trigger').click(function (e) {
    e.preventDefault();
    $(this).siblings('ul').slideToggle(200);
});


/* Substitute Text of Custom Dropdown
$('.custom-dropdown li a').click(function(){

    var text = $(this).text();
    var parentDiv = $(this).closest('.custom-dropdown');

    $(parentDiv).children('.dropdown-trigger').html(text);
});
*/


$('.close').click(function (e) {
    e.preventDefault();
    $('#search-bar').slideToggle(200);
    $('body,html').animate({
            scrollTop: 0
        }, 300
    );
});

$('.icon-nav-arrow').click(function () {
    $(this).parents('li').children('.dropdown').addClass('active');
});
$('.back').click(function () {
    $(this).parents('.dropdown').removeClass('active');

});

const timelineMonths = [
    'September',
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May'
];

function initiateTimelineSlider(tabLabel) {
    let timelineSelector = '#timelineSliderTab1';

    if (tabLabel === 'tab2') {
        timelineSelector = '#timelineSliderTab2';
    }

    if (!$(timelineSelector).hasClass('slick-initialized')) {
        const $timelineSlider = $(timelineSelector);
        const $timelineDates = $timelineSlider.parent().find('.timeline-slider__dates');
        const $timelineDots = $(timelineSelector).parent().find('.timeline-slider__dots--mobile');
        const $timelineDotsTabletUp = $(timelineSelector).parent().find('.timeline-slider__dots--tablet-up');

        const sliderDotsSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: $timelineSlider,
            variableWidth: false,
            arrows: false,
            mobileFirst: true,
            infinite: false,
            rows: 1,
            responsive: [
                {
                    breakpoint: 760,
                    settings: 'unslick'
                }
            ]
        };

        $timelineDots.slick(sliderDotsSettings);

        $timelineSlider.slick({
            asNavFor: $timelineDots,
            adaptiveHeight: true,
            speed: 600,
            appendArrows: $timelineDates,
            prevArrow: "<button type='button' class='slick-prev pull-left'><i class='icon-nav-arrow' aria-hidden='true'></i></button>",
            nextArrow: "<button type='button' class='slick-next pull-right'><i class='icon-nav-arrow'" +
                " aria-hidden='true'></i></button>",
            infinite: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 760,
                    settings: {
                        asNavFor: null,
                        dots: true,
                        adaptiveHeight: false,
                        appendArrows: $timelineSlider,
                        appendDots: $timelineDotsTabletUp,
                        customPaging: function (slider, i) {
                            return '<button class="timeline-slider__dot">' + timelineMonths[i] + '</button>';
                        }
                    }
                }
            ]
        });

        $(window)
            .resize(function () {
                $timelineDots.slick('init');

                if ($(window).width() < 760) {
                    $timelineDots.slick(sliderDotsSettings, 'resize');
                }
            });
    }
}

// Initialize Progress Bar Meter
$(document).ready(function () {
    meterReset();

    initiateTimelineSlider('tab1');

    $('#testimonialSlider').slick({
        asNavFor: '.testimonial-slider__dots',
        adaptiveHeight: true,
        speed: 600,
        dots: true,
        appendDots: '.testimonial-slider__dots',
        appendArrows: '.testimonial-slider__arrows',
        prevArrow: "<button type='button' class='slick-prev pull-left'><i class='icon-nav-arrow' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><i class='icon-nav-arrow'" +
            " aria-hidden='true'></i></button>",
        infinite: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1020,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 760,
                settings: {
                    asNavFor: null,
                    dots: true,
                    adaptiveHeight: false,
                    slidesToShow: 2,
                    // customPaging: function (slider, i) {
                    //     return '<button class="timeline-slider__dot">' + timelineMonths[i] + '</button>';
                    // }
                }
            }
        ]
    });
    /**
     * STICKY NAV
     */
    const stickyNav      = document.querySelector('.timeline-slider__dates');
    const timelineSlider = document.querySelector('.timeline-slider');

    if (stickyNav) {
        const stickPoint = stickyNav.offsetTop;

        const isTimelineSliderShowing = scrollPosition => scrollPosition < timelineSlider.offsetTop + timelineSlider.getBoundingClientRect().height - 200;

        const isMobile = () => window.innerWidth < 760;

        const toggleStickyNav = () => {
            if (window.pageYOffset > stickPoint && isTimelineSliderShowing(window.pageYOffset) && isMobile()) {
                stickyNav.classList.add('timeline-slider__dates--sticky');
                document.body.style.paddingTop = `${stickyNav.getBoundingClientRect().height}px`;
            } else {
                stickyNav.classList.remove('timeline-slider__dates--sticky');
                document.body.style.paddingTop = `0`;
            }
        };

        // On scroll
        const onScroll = () => {
            toggleStickyNav();
        };

        window.addEventListener('scroll', onScroll);
    }

    //Publication page
    $('.table-of-contents .content-trigger').click(function (e) {
        e.preventDefault();
        $(this).siblings('ul').slideToggle();
    });

    // Retrieve all Headings and place them in table of contents
    $('.content-section .title-text h2').each(function () {

        var thisElement   = $(this);
        var titleText     = $(thisElement).html();
        var titleArray    = $.makeArray(titleText);
        var titleID       = $(thisElement).closest('.content-section').attr('id');
        var contentsTable = $('.table-of-contents ul');

        $(contentsTable).append('<li><a href="#' + titleID + '">' + titleArray + '</a></li>');

    });

    $('.table-of-contents li a[href*=#]').on('click', function (event) {
        event.preventDefault();
        $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 500);
    });
});

// Wrap all select elements in select-holder for styling purposes
if ($('form select').length > 0) {
    $('form select').wrap('<div class="select-holder"></div>');
}

// check for table in content area and add responsive wrapper
if ($('.content table').length > 0) {
    $('.content table').wrap("<div class='table-container'></div>")
}

$('.more, .loggedin-nav').click(function () {
    $('.more, .loggedin-nav').toggleClass('active');
});

$('.dropdown select').change(function () {
    var option = $(this).children('option:selected').text();
    $(this).parent().siblings('.styled-dropdown').children('.selected-text').text(option);
});

$('.selected-text').click(function (e) {
    $('.option-list').not($(this).siblings('.option-list')).slideUp(50);
    $(this).siblings('.option-list').slideToggle(100);
});

$('.option-list li').click(function (e) {
    var option = $(this).text();
    $(this).parent().siblings('.selected-text').text(option);
    $('.option-list').slideUp(100);
    $(this).parents('.dropdown').find('option:contains("' + option + '")').attr('selected', 'selected');
});




